module.exports = __webpack_public_path__ + "static/media/lamina16text2.3dfeae96.png";